import { useTranslator } from '@bluebeam/react-i18n';
import EmptyState from 'components/Icons/EmptyState';
import React from 'react';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  id: string;
  onViewAllClicked: (projectId: string) => void;
  onActiveClicked?: (projectId: string) => void; // Is this used?
  onOverdueClicked?: (projectId: string) => void; // Is this used?
  onCreateClicked: (projectId: string) => void;
  title: string;
  count: number;
  createLabel: string;
  emptyLabel: string;
  emptyMsg: string;
  icon: React.ReactNode;
  items: React.ReactNode;
  hasPermission: boolean;
}

const CountsCard: React.FC<Props> = (props: Props) => {
  const {
    id,
    title,
    count,
    createLabel,
    emptyLabel,
    emptyMsg,
    icon,
    items,
    hasPermission,
    onViewAllClicked,
    onCreateClicked,
    appState,
  } = props;
  const { selectedProject } = appState;
  const { translate } = useTranslator(['roverDashboard']);

  return (
    <div id={id} className="column w100">
      <div className="flex justify-between mb2">
        <div className="row items-center medium color-gray-7 font-size-5">
          <div className="wrem-1p5 hrem-1p5 mr1 icon flex-center primary-blue">
            {icon}
          </div>
          <div>{title}</div>
        </div>
        <div
          className="bold font-size-5"
          style={{ visibility: count > 0 ? 'visible' : 'hidden' }}
          onClick={(): void => {
            onViewAllClicked(selectedProject);
          }}
        >
          <button
            id={`${id}-view-all-btn`}
            className="btn-sm btn-link-primary row items-center justify-between"
            onClick={(): void => {
              onViewAllClicked(selectedProject);
            }}
          >
            <span className="color-gray-7 font-size-2">
              {translate('roverDashboard:viewAll')}
            </span>
          </button>
        </div>
      </div>
      <div className="bgd-section b-radius-3 h100" style={{ height: '172px' }}>
        {count > 0 ? (
          <div>{items}</div>
        ) : (
          <div className="grow-1 flex-center h100">
            {hasPermission ? (
              <div className="m4">
                <button
                  id={`${id}-create-btn`}
                  className="btn-sm btn-primary"
                  onClick={(): void => {
                    onCreateClicked(selectedProject);
                  }}
                >
                  {createLabel}
                </button>
              </div>
            ) : (
              <div className="column justify-center items-center mt1">
                <div className="mb3 fill-gray-5">
                  <EmptyState width="64px" height="64px" />
                </div>
                <div className="font-size-4 bold color-gray-9 mb2 column center">
                  {emptyLabel}
                </div>
                <div className="font-size-4 color-gray-9 mb2 column center">
                  {emptyMsg}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default withAppStore<Props>(CountsCard);
